import "./TimeRangeResult.html";
import "./TimeRangeResult.scss";

import "./RangeResultDirective";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import TimeRangeResultComponentController from "./TimeRangeResultComponentController";

export default class TimerRangeResultComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            baseColorTheme: "<", // purple, blue, green - default
            lowResolutionMode: "<",
            resultDaySchedule: "<",
        };
        this.controller = TimeRangeResultComponentController;
        this.templateUrl = "/App/Components/Forms/TimeRangeResult/TimeRangeResult.html";
    }
}

module("mmManagePortal").component("irTimeRangeResult", new TimerRangeResultComponent());
